import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './configurator.routes';
import basicLayout from './basicLayout';
import background from './background';
import border from './border';
import images from './images';
import text from './text';
import shapes from './shapes';
import finish from './finish';

export class ConfiguratorController {
  $scope
  $rootScope
  canvas
  $state

  /*@ngInject*/
  constructor($scope, $rootScope, Canvas, $state) {
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.canvas = Canvas;
    this.$state = $state;
  }

  $onInit() {
    this.canvas.setStageDefaults();
    this.canvas.stageInitialized(function(stage) {});

    this.$scope.isZIndexToolbarVisible = false;
    this.$scope.onArrange = action => {
      this.$rootScope.$emit('onArrange', action);
    };

    this.canvas.events.addListener('canvas.onItemSelected', this.onCanvasItemSelected);
    this.$scope.$on('$destroy', () => {
      this.canvas.events.removeListener('canvas.onItemSelected', this.onCanvasItemSelected);
    });
  }

  onCanvasItemSelected = e => {
    const { type } = e.item;
    const { name } = this.$state.current;
    let should;

    switch (type) {
    case 'text':
      should = 'app.canvas.toolset-text';
      break;
    case 'image':
      should = 'app.canvas.toolset-images';
      break;
    case 'shape':
      should = 'app.canvas.toolset-shapes';
      break;
    }

    if(name !== should) {
      this.$rootScope.selectMainMenuItem(should).then(() => {
        // Re-emit the event after a short delay
        setTimeout(() => {
          this.canvas.setItemSelection(e.item);
        }, 100);
      });
    }
  }
}

export default angular
  .module('app.configurator', ['komCanvasConfiguratorApp.auth', uiRouter, basicLayout, background, border, images, text, shapes, finish])
  .config(routing)
  .component('configurator', {
    template: require('./configurator.html'),
    controller: ConfiguratorController
  }).name;



// WEBPACK FOOTER //
// ./client/app/configurator/configurator.component.js